import * as React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
// @mui
import { Autocomplete, Popover, Button, Stack, TextField, Container } from '@mui/material';

// Calendario
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt-BR';

import { getUsuarios, getFornecedores, getFormasPagamento, getGenericData } from './api';

import { useUnidades, isSameUnidade } from '../hooks/useUnidades';

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars
const PopoverFiltroRelatorio = React.forwardRef((props, ref) => {
  const [filtro, setFiltro] = useState(props.filtro);
  const [usuarios, setUsuarios] = useState([]);
  const [estados, setEstados] = useState([]);
  const { unidades } = useUnidades();
  const [fornecedores, setFornecedores] = useState([]);
  const formasAtendimento = ['Prospecção', 'Agendamento', 'Lead', 'Indicação'];
  const [formasPagamento, setFormasPagamentos] = useState([]);
  const [centroCustos, setCentroCustos] = useState([])
  const [contaPagamentos, setContaPagamentos] = useState([])

  useEffect(() => {
    const fetchFormasPagamento = async () => {
      const result = await getFormasPagamento();
      setFormasPagamentos(result);
    };
    fetchFormasPagamento();
  }, []);

  useEffect(() => {
    const fetchFornecedores = async () => {
      const result = await getFornecedores();
      setFornecedores(result);
    };
    fetchFornecedores();
  }, []);

  const [servicosCadastrados, setServicosCadastrados] = useState([]);
  useEffect(() => {
    const fetchServicos = async () => {
      const result = await getGenericData('servico');
      setServicosCadastrados(result || []);
    };
    fetchServicos();
  }, []);

  const [produtos] = useState([
    'Gerador On-Grid',
    'Gerador Off-Grid',
    'Sistema de Bombeamento',
    'Proposta Comercial',
    'Proposta de Serviços',
  ]);

  useEffect(() => {
    fectchUsuarios();
  }, []);
  const fectchUsuarios = async () => {
    const resultado = await getUsuarios();
    setUsuarios(resultado);
  };

  useEffect(() => {
    const fetchCentroCusto = async () => {
      const result = await getGenericData('centrocusto');
      setCentroCustos(result);
    };
    fetchCentroCusto();
  }, []);

  useEffect(() => {
    const fetchContasBancarios = async () => {
      const result = await getGenericData('contasbancario');
      setContaPagamentos(result);
    };
    fetchContasBancarios();
  }, []);

  useEffect(() => {
    fetchEstados();
  }, []);
  const fetchEstados = async () => {
    fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erro na solicitação');
        }
        return response.json();
      })
      .then((estados) => {
        const estadosOrdenados = estados.sort((a, b) => a.nome.localeCompare(b.nome));
        setEstados(estadosOrdenados);
      })
      .catch((error) => {
        console.error('Erro ao obter os estados:', error);
      });
  };

  // Calendario
  // Calendario 1 (Data Inicial)
  const [openCalendar1, setOpenCalendar1] = useState(false);
  const [openCalendar3, setOpenCalendar3] = useState(false);
  const [openCalendar4, setOpenCalendar4] = useState(false);
  const [openCalendar5, setOpenCalendar5] = useState(false);
  const [openCalendar6, setOpenCalendar6] = useState(false);
  
  const handleCalendarOpen1 = () => {
    setOpenCalendar1(true);
  };
  const handleCalendarClose1 = () => {
    setOpenCalendar1(false)
    setOpenCalendar2(false)
    setOpenCalendar3(false)
    setOpenCalendar4(false)
    setOpenCalendar5(false)
    setOpenCalendar6(false)
  };
  const handleDateChange1 = (date, field) => {
    const dataini = 'datainicial'
    setFiltro({ ...filtro, [field ?? dataini]: date });
    handleCalendarClose1()
  };

  // Calendario 2 (Data Final)
  const [openCalendar2, setOpenCalendar2] = useState(false);
  const handleCalendarOpen2 = () => {
    setOpenCalendar2(true);
  };
  const handleCalendarClose2 = () => {
    setOpenCalendar1(false)
    setOpenCalendar2(false)
    setOpenCalendar3(false)
    setOpenCalendar4(false)
    setOpenCalendar5(false)
    setOpenCalendar6(false)
  };
  const handleDateChange2 = (date, field) => {
    const datafim = 'datafinal'
    setFiltro({ ...filtro, [field ?? datafim]: date });
    setOpenCalendar1(false)
    setOpenCalendar2(false)
    setOpenCalendar3(false)
    setOpenCalendar4(false)
    setOpenCalendar5(false)
    setOpenCalendar6(false)
  };

  // Calendario

  const handleConfirm = () => {
    props.onConfirm(filtro);
  };
  return (
    <Popover
      open={Boolean(props.open)}
      anchorEl={props.open}
      onClose={props.onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          p: 1,
          width: 'auto+10',
          height: '100%',
          flex: 1,
          display: 'flex',
          '& .MuiMenuItem-root': {
            px: 1,
            typography: 'body2',
            borderRadius: 0.75,
          },
        },
      }}
    >
      <Stack flex={1} gap={1} sx={{ height: 'auto' }}>
        <Stack direction={'row'} gap={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar1}
              onOpen={handleCalendarOpen1}
              onClose={handleCalendarClose1}
              value={filtro.datainicial}
              onChange={handleDateChange1}
              renderInput={(params) => <TextField {...params} label="Data Inicial" />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
            <DatePicker
              open={openCalendar2}
              onOpen={handleCalendarOpen2}
              onClose={handleCalendarClose2}
              value={filtro.datafinal}
              onChange={handleDateChange2}
              renderInput={(params) => <TextField {...params} label="Data Final" />}
            />
          </LocalizationProvider>
        </Stack>

        <Autocomplete
          disablePortal
          id="unidade"
          value={filtro.unidade || null}
          options={unidades}
          isOptionEqualToValue={isSameUnidade}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} label="Unidade" />}
          onChange={(event, newValue) => {
            setFiltro({ ...filtro, unidade: newValue });
          }}
        />
        {(props.type === 'vendas' || props.type === 'vendasServico') && (
          <>
            <Autocomplete
              disablePortal
              id="vendedorAbertura"
              value={filtro.vendedorAbertura}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, vendedorAbertura: newValue });
              }}
              options={usuarios}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Vendedor Abertura" />}
            />

            <Autocomplete
              disablePortal
              id="vendedorFechamento"
              value={filtro.vendedorFechamento}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, vendedorFechamento: newValue });
              }}
              options={usuarios}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Vendedor Fechamento" />}
            />

            <Autocomplete
              disablePortal
              id="estado"
              value={filtro.estado}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, estado: newValue });
              }}
              options={estados.map((e) => e.nome)}
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => `${option}`}
              renderInput={(params) => <TextField {...params} label="Selecione o Estado" />}
            />

            <Autocomplete
              disablePortal
              id="formaAtendimento"
              value={filtro.formaAtendimento || null}
              options={formasAtendimento}
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => `${option}`}
              renderInput={(params) => <TextField {...params} label="Forma Atendimento" />}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, formaAtendimento: newValue });
              }}
            />

            <Autocomplete
              disablePortal
              id="formaPagamento"
              value={filtro.formaPagamento || null}
              options={formasPagamento}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Forma Pagamento" />}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, formaPagamento: newValue });
              }}
            />

            {props.type === 'vendasServico' && (
              <Autocomplete
                disablePortal
                id="servico"
                value={filtro.servico || null}
                onChange={(event, newValue) => setFiltro({ ...filtro, servico: newValue })}
                options={servicosCadastrados.map((s) => s.nome)}
                isOptionEqualToValue={(option, value) => option === value}
                getOptionLabel={(option) => `${option}`}
                renderInput={(params) => <TextField {...params} label="Tipo de Serviço" />}
              />
            )}
          </>
        )}

        {props.type === 'despesas' && (
          <>
            <Stack direction={'row'} gap={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
                <DatePicker
                  open={openCalendar3}
                  onOpen={() => setOpenCalendar3(true)}
                  onClose={() => setOpenCalendar3(false)}
                  value={filtro.vencimentoinicial || null}
                  onChange={(date) => handleDateChange1(date,'vencimentoinicial')}
                  renderInput={(params) => <TextField {...params} label="Vencimento Inicial" />}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
                <DatePicker
                  open={openCalendar4}
                  onOpen={() => setOpenCalendar4(true)}
                  onClose={() => setOpenCalendar4(false)}
                  value={filtro.vencimentofinal || null}
                  onChange={(date) => handleDateChange2(date,'vencimentofinal')}
                  renderInput={(params) => <TextField {...params} label="Vencimento Final" />}
                />
              </LocalizationProvider>
            </Stack>

            <Stack direction={'row'} gap={2}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
                <DatePicker
                  open={openCalendar5}
                  onOpen={() => setOpenCalendar5(true)}
                  onClose={() => setOpenCalendar5(false)}
                  value={filtro.pagamentoinicial || null}
                  onChange={(date) => handleDateChange1(date,'pagamentoinicial')}
                  renderInput={(params) => <TextField {...params} label="Pagamento Inicial" />}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
                <DatePicker
                  open={openCalendar6}
                  onOpen={() => setOpenCalendar6(true)}
                  onClose={() => setOpenCalendar3(false)}
                  value={filtro.pagamentofinal || null}
                  onChange={(date) => handleDateChange2(date,'pagamentofinal')}
                  renderInput={(params) => <TextField {...params} label="Pagamento Final" />}
                />
              </LocalizationProvider>
            </Stack>
            
            <Autocomplete
              disablePortal
              id="formaPagamento"
              value={filtro.formaPagamento || null}
              options={formasPagamento}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Forma Pagamento" />}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, formaPagamento: newValue });
              }}
            />

            <Autocomplete
              disablePortal
              id="centrocusto"
              value={filtro.centroCusto || null}
              options={centroCustos}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Centro de Custo" />}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, centroCusto: newValue });
              }}
            />

            
            <Autocomplete
              disablePortal
              id="centrocusto"
              value={filtro.contaPagamento || null}
              options={contaPagamentos}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => `${option.nome}`}
              renderInput={(params) => <TextField {...params} label="Conta Pagamento" />}
              onChange={(event, newValue) => {
                setFiltro({ ...filtro, contaPagamento: newValue });
              }}
            />
          </>
        )}

        {props.type === 'custosServico' && (
          <>
            <Autocomplete
              disablePortal
              id="responsavel"
              value={filtro.responsavel || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, responsavel: newValue })}
              options={usuarios}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => option.nome}
              renderInput={(params) => <TextField {...params} label="Engenheiro Responsável" />}
            />
            <Autocomplete
              disablePortal
              id="servico"
              value={filtro.servico || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, servico: newValue })}
              options={servicosCadastrados.map((s) => s.nome)}
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => `${option}`}
              renderInput={(params) => <TextField {...params} label="Tipo de Serviço" />}
            />
          </>
        )}

        {props.type === 'orcamentosServico' && (
          <>
            <Autocomplete
              disablePortal
              id="consultor"
              value={filtro.consultor || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, consultor: newValue })}
              options={usuarios}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => option.nome}
              renderInput={(params) => <TextField {...params} label="Consultor" />}
            />
            <Autocomplete
              disablePortal
              id="servico"
              value={filtro.servico || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, servico: newValue })}
              options={servicosCadastrados.map((s) => s.nome)}
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => `${option}`}
              renderInput={(params) => <TextField {...params} label="Tipo de Serviço" />}
            />
          </>
        )}

        {props.type === 'rejeitadasServico' && (
          <>
            <Autocomplete
              disablePortal
              id="consultor"
              value={filtro.consultor || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, consultor: newValue })}
              options={usuarios}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => option.nome}
              renderInput={(params) => <TextField {...params} label="Consultor" />}
            />
            <Autocomplete
              disablePortal
              id="servico"
              value={filtro.servico || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, servico: newValue })}
              options={servicosCadastrados.map((s) => s.nome)}
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => `${option}`}
              renderInput={(params) => <TextField {...params} label="Tipo de Serviço" />}
            />
          </>
        )}

        {(props.type === 'rejeitadas' || props.type === 'rejeitadasCpfCnpj' || props.type === 'propostas') && (
          <>
            <Autocomplete
              disablePortal
              id="consultor"
              value={filtro.consultor || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, consultor: newValue })}
              options={usuarios}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={(option) => option.nome}
              renderInput={(params) => <TextField {...params} label="Consultor" />}
            />
            <Autocomplete
              disablePortal
              id="produto"
              value={filtro.produto || null}
              onChange={(event, newValue) => setFiltro({ ...filtro, produto: newValue })}
              options={produtos}
              isOptionEqualToValue={(option, value) => option === value}
              getOptionLabel={(option) => option}
              renderInput={(params) => <TextField {...params} label="Produto" />}
            />
          </>
        )}

        <Container sx={{ marginTop: 2 }}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={props.onLimpar}>
              Limpar
            </Button>

            <Button variant={'contained'} color={'success'} onClick={handleConfirm}>
              Filtrar
            </Button>
          </Stack>
        </Container>
      </Stack>
    </Popover>
  );
});

PopoverFiltroRelatorio.propTypes = {
  open: PropTypes.object,
  onClose: PropTypes.func,
  onLimpar: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default PopoverFiltroRelatorio;